import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {IDialogComponent} from '../../../../../common/dialog/iDialog.component';
import {CommunicationContentModelModel} from '../../entity/communicationContentModel.model';
import {DialogWithInput} from '../../../../../common/dialog/dialogWithInput';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {
  CommunicationContentModelFindOneByIdService
} from '../../../impl/service/communicationContentModelFindOneById.service';
import {CommunicationContentModelSaveService} from '../../../impl/service/ save/communicationContentModelSave.service';
import {CommunicationContentModelSavePayload} from '../../../impl/service/ save/communicationContentModelSave.payload';
import {
  CreateUpdateDefaultComponent
} from '../../../../../core/component/create-update-default/create-update-default.component';
import {ObjectUtils} from '../../../../../../shared/utils/object.utils';
import {
  CommunicationContentSubstitutionModel
} from '../../../../content-substitution/api/model/communicationContentSubstitution.model';
import {Subscription} from 'rxjs';
import {
  CommunicationContentSubstitutionFindAllService
} from '../../../../content-substitution/impl/service/ngrx/communicationContentSubstitutionFindAll.service';
import {Order, Sort} from '../../../../../../shared/utils/url.builder';
import {RichTextEditorComponent} from '../../../../../../components/common/rich-text-editor/rich-text-editor.component';
import {UrlParameterBuilder} from "../../../../../core/http/UrlParameterBuilder";

export interface CommunicationContentModelSaveDialogInput {
  id?: number;
  initialContent?: string;
  typeValue?: string;
  substitutionAdditionalCategoryValues?: string[];
}

export interface CommunicationContentModelSaveDialogResult {
  created: boolean;
  entity: CommunicationContentModelModel;
}

@Component({
  selector: 'app-communication-content-model-save-dialog',
  templateUrl: './communication-content-model-save-dialog.component.html',
  viewProviders: [
    CommunicationContentModelFindOneByIdService,
    CommunicationContentModelSaveService,
    CommunicationContentSubstitutionFindAllService,
  ]
})
export class CommunicationContentModelSaveDialogComponent
    implements IDialogComponent<CommunicationContentModelSaveDialogInput, CommunicationContentModelSaveDialogResult>, OnInit, OnDestroy {

  dialog: DialogWithInput<CommunicationContentModelSaveDialogInput, CommunicationContentModelSaveDialogResult>;
  id: number;
  formGroup: UntypedFormGroup;
  creation = false;
  initialContent: string;
  @ViewChild('createUpdateDefaultComponent') createUpdateDefaultComponent: CreateUpdateDefaultComponent<any, any, any>;
  @ViewChild('richTextEditorComponent') richTextEditorComponent: RichTextEditorComponent;

  substitutionCategories: SubstitutionCategory[] = [];

  subscriptions: Subscription[] = [];
  constructor(private formBuilder: UntypedFormBuilder,
              public findOneService: CommunicationContentModelFindOneByIdService,
              public saveService: CommunicationContentModelSaveService,
              public substitutionService: CommunicationContentSubstitutionFindAllService) {
    this.formGroup = this.formBuilder.group({
      summary: this.formBuilder.group({
        id: this.formBuilder.control(undefined)
      }),
      label: this.formBuilder.control(undefined, Validators.required),
      typeValue: this.formBuilder.control(undefined, Validators.required),
      content: this.formBuilder.control(undefined, Validators.required),
      active: this.formBuilder.control(true, Validators.required),
    });

    this.subscriptions.push(this.substitutionService.entities$
        .subscribe(value => {
          this.substitutionCategories = [];
          if (value) {
            value.forEach(value => {
              let category = this.substitutionCategories.find(value1 => value1.value === value.category.value);
              if (! category) {
                category = {
                  label: value.category.label,
                  value: value.category.value,
                  substitutions: []
                };
                this.substitutionCategories.push(category);
              }
              category.substitutions.push(value);
            });
          }

          // sort
          console.log(this.substitutionCategories);
          this.substitutionCategories.forEach(value1 => value1.substitutions.sort((a, b) => a.name.localeCompare(b.name)))
          console.log(this.substitutionCategories);
          this.substitutionCategories.sort((a, b) => a.label.localeCompare(b.label));

        }));
  }

  ngOnInit() {
    this.id = this.dialog.input.id;
    this.creation = !this.id;
    this.initialContent = this.dialog.input.initialContent;
    if (this.initialContent && ! this.id) {
      this.formGroup.get('content').setValue(this.initialContent);
    }
    if (this.dialog.input.typeValue && ! this.id) {
      this.formGroup.get('typeValue').setValue(this.dialog.input.typeValue);
    }
    if (this.dialog.input.substitutionAdditionalCategoryValues) {
      this.substitutionService.parameters = new UrlParameterBuilder().addInParameter('additionalCategory.value', this.dialog.input.substitutionAdditionalCategoryValues)
          .parameters;
    }
    this.substitutionService.sort = new Sort('name', Order.ASCENDING);
    this.substitutionService.findAll();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(value => value.unsubscribe());
  }

  entitySaved(entity: CommunicationContentModelModel){
    this.close(entity);
  }

  entityLoaded(entity: CommunicationContentModelModel) {
    this.formGroup.patchValue({
      summary: {
        id: entity.summary.id
      },
      label: entity.summary.label,
      typeValue: entity.summary.type.value,
      content: this.initialContent ? this.initialContent : entity.content,
      active: entity.summary.active
    });
  }

  substitutionClicked(substitution: CommunicationContentSubstitutionModel) {
    if (substitution){
      this.richTextEditorComponent.insertString('|' + substitution.textToReplace + '|');
    }
  }

  onClose() {
    this.close();
  }

  close(entity?: CommunicationContentModelModel) {
    if (entity) {
      this.dialog.dialog.close({
        created: this.creation,
        entity
      });
    } else {
      this.dialog.dialog.close(undefined);
    }
  }

  buildPayload = (): CommunicationContentModelSavePayload => {
     const payload = ObjectUtils.assign(new CommunicationContentModelSavePayload(), this.formGroup.value);
     return payload;
  }

  executeSave() {
    this.createUpdateDefaultComponent.save();
  }
}

export class SubstitutionCategory {
  value: string;
  label: string;
  substitutions: CommunicationContentSubstitutionModel[] = [];
}
